import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { HttpStateLine } from 'state-line';
import Container from 'xgimi-ui/Container';
import LoadingContainer from 'xgimi-ui/LoadingContainer';
import images from '../../../assets/images';
import StoreComponent, { mapStateToProps } from '../../../appComponents/Store';
import List from './List';
import Api from '../../../api';
import s from './.module.scss';

interface Props {
}

interface States {
  historyList: Record<string, any>[];
  isGettingHistoryList: boolean;
  showTips: boolean;
}

/**
 * 历史反馈
 */
class Component extends StoreComponent<Props, States> {
  state: States = {
    historyList: [],
    isGettingHistoryList: false,
    showTips: false,
  };

  constructor(props: Props) {
    super(props, { languageKey: 'page.feedback', titleKey: 'history' });
  }

  componentDidMount() {
    this.getRecord();
  }

  /**
   * 获取历史列表
   */
  private getRecord = async (): Promise<void> => {
    this.setState({ isGettingHistoryList: true });
    const httpStateLine = await new HttpStateLine(new Api.feedback.GetRecord({
      uid: this.storeState.userCenter.userInfo?.uid,
      currentPage: 1,
    })).run().catch(() => null);
    if (httpStateLine) {
      const historyList = httpStateLine?.result?.data.data;
      this.setState({ historyList });
      this.setState({
        historyList,
        isGettingHistoryList: false,
      });
    }
  };

  render(): React.ReactNode {
    return (
      <Container className={s.container} isMobile={true}>
        <LoadingContainer
          isLoading={this.state.historyList.length === 0 && this.state.isGettingHistoryList}
          isData={this.state.historyList.length > 0}
          message={''}
          messageComponent={(
            <div className={s.top}>
              <img src={images.emptyHistory} alt="success" className={s.image}/>
              <div className={s.empty}>{this.t('historyEmpty')}</div>
              <div className={s.thank}>{this.t('welcome')}</div>
              <Link to={`/feedback${window.location.search}`} className={s.gotoFeed}>
                {this.t('gotoFeed')}
              </Link>
            </div>
          )}
        >
          <List historyList={this.state.historyList} isDetail={false} title="历史反馈" />
          <div className={s.bottom}>{this.t('bottom')}</div>
        </LoadingContainer>
      </Container>
    );
  }
}

export default connect(mapStateToProps)(Component);
